'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "listStyleReset"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { Type } from "../Type/index.mjs";
import styled from "../../styled-components.mjs";
var TypeListItemElement = styled(Type).withConfig({
  displayName: "TypeListItem__TypeListItemElement",
  componentId: "sc-q1l2mf-0"
})(["display:list-item;padding-block-end:", ";", ";"], function (props) {
  return !props.condensed && '1em';
}, function (props) {
  return props.listStyleReset && "list-style-type: none";
});

/**
* **TypeListItem** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TypeListItem) 
*
* TypeListItem is an individual unit in the TypeList
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/type?format=figma-figma#list-text)
*
* @example
* () => <TypeListItem>Aenean lacinia</TypeListItem>;
*
*/
export var TypeListItem = /*#__PURE__*/React.forwardRef(function TypeListItem(_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'li' : _ref$as,
    _ref$listStyleReset = _ref.listStyleReset,
    listStyleReset = _ref$listStyleReset === void 0 ? false : _ref$listStyleReset,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TypeListItemElement, Object.assign({}, props, {
    ref: ref,
    forwardedAs: as,
    listStyleReset: listStyleReset,
    "data-encore-id": ENCORE_DATA_IDS.TypeListItem
  }));
});